/**
 * @enum {number} challenge activity type id
 *
 * ref: SocialChallengeActivityType.java
 */
export const CHALLENGE_ACTIVITY_TYPE_ID = {
    WALKING: 0,
    RUNNING: 1,
    CYCLING: 2,
    SWIMMING: 3,
    WELLNESS_STEPS_COUNT: 4,
    WELLENSS_STEPS_DISTANCE: 5,
    CALORIES_BURNED: 6,
    ACTIVE_MINUTES: 7,
    GOALS: 8,
    WELLNESS_STEPS_COUNT_TEAMS_AVERAGE: 9,
    WELLNESS_PUSHES_COUNT: 10,
    /**
     * para_sports
     */
    PUSHING_DISTANCE: 11
};

/**
 * @enum {number} challenge status.
 *
 * use in different type challenges, like adHocChallenge.socialChallengeStatusId.
 *
 * ref: GroupChallengeStatus.java
 */
export const CHALLENGE_STATUS_ID = {
    READY: 0,
    STARTED: 1,
    STOPPED: 2,
    LOCKED: 3,
    COMPLETED: 4,
    FULL: 5 // this is defined in `GroupChallengeTypesMapper`, but not in `GroupChallengeStatus.java`
};

/**
 * @enum {number} social challenge type id
 *
 * ref: SocialChallengeType.java
 */
export const SOCIAL_CHALLENGE_TYPE_ID = {
    AUTO_CHALLENGE: 0,
    GROUP_CHALLENGE: 1,
    ADHOC_CHALLENGE: 2,
    VIVOKID_ADHOC_CHALLENGE: 3,
    VIVOKID_TEAM_CHALLENGE: 4,
    TEAM_CHALLENGE: 5,
    BADGE_CHALLENGE: 6,
    EXPEDITIONS: 7
};

/**
 * @enum {number} VivoKid challenge player type
 *
 * ref: PlayerType.java
 */
export const PLAYER_TYPE_ID = {
    DEFAULT: 0,
    GUARDIAN: 1,
    KID: 2
};

/**
 * @enum {number} AutoChallengeResponseDTO reasonCode
 */
export const AUTO_CHALLENGE_RESPONSE_MESSAGE_ID = {
    HAS_CHALLENGE: 0,
    USER_OPTED_OUT: 1,
    USER_DOES_NOT_HAVE_WELLNESS_PROFILE: 2,
    CHALLENGE_REQUEST_IS_IN_PENDING_STATE: 3,
    UNKNOWN_REASON: 4
};

/**
 * @enum {number}
 */
export const AUTO_CHALLENGE_STATUS_ID = {
    NOT_READY: 0,
    NOT_IN_CHALLENGE: 1,
    PENDING: 2,
    SHOW: 3,
    UNKNOWN: 4,
    IN_EVALUATION: 5
};
